import { Paragraph } from "@/atoms"
import { isVendorTicketingSystem } from "@/domain/ticketing"
import { useTranslation } from "@/hooks/useTranslation"
import { KodemLogo } from "@/icons"
import { AsanaWorkspaceChoice } from "@/pages/IntegrationsPage/components/organisms/AsanaWorkspaceChoice"
import { IntegrationStatusButtonsContainer } from "../../molecules/IntegrationStatusButtonsContainer"
import { IntegrationStatusIcon } from "../../molecules/IntegrationStatusIcon"
import { LogoIntegration } from "../../molecules/LogoIntegration"

import styles from "./IntegrationStatus.module.scss"

import type { StatusComponentProps } from "."

export const StatusComponent = (props: StatusComponentProps) => {
  const { vendor, status, errorMessage, workspaces = [] } = props
  const { t } = useTranslation("translation", {
    keyPrefix: "integrations.callback"
  })
  const { t: tSystems } = useTranslation("translation", {
    keyPrefix: "ticketing.systems"
  })
  const { t: tWorkspace } = useTranslation("translation", {
    keyPrefix: "integrations.asana.form.workspace"
  })
  // Azure Boards and Asana are named once, under ticketing.systems
  const vendorName = isVendorTicketingSystem(vendor)
    ? tSystems(vendor)
    : t(`vendors.${vendor}`, "Unknown Vendor")
  const showDescription = vendor === "github" || vendor === "bitbucket"
  const choosesWorkspace = !!workspaces.length
  const buttons = (
    <IntegrationStatusButtonsContainer {...props} vendorName={vendorName} />
  )

  return (
    <div className={styles.container}>
      <div className={styles.logoContainer}>
        <LogoIntegration onlyLogo name={vendor} className={styles.vendorIcon} />
        <div className={styles.dotContainer}>
          <div className={styles.dot} />
          <div className={styles.dot} />
          {!choosesWorkspace && (
            <IntegrationStatusIcon integrationStatus={status} />
          )}
          <div className={styles.dot} />
          <div className={styles.dot} />
        </div>
        <KodemLogo className={styles.logoIcon} />
      </div>
      <div className={styles.textContainer}>
        <Paragraph className={styles.title} type="secondary">
          {choosesWorkspace
            ? tWorkspace("title")
            : t(`${status}.text`, {
                name: vendorName,
                defaultValue: "Unknown Status"
              })}
        </Paragraph>
        {showDescription && (
          <Paragraph className={styles.description} type="secondary">
            {t("description")}
          </Paragraph>
        )}
        {errorMessage && (
          <Paragraph className={styles.description} type="secondary">
            {errorMessage}
          </Paragraph>
        )}
      </div>
      {choosesWorkspace ? (
        <AsanaWorkspaceChoice workspaces={workspaces}>
          {buttons}
        </AsanaWorkspaceChoice>
      ) : (
        buttons
      )}
    </div>
  )
}
